<!-- BRouter Map Modal -->
<ng-template #trackMapModal let-modalRef="modalRef">
  <div class="modal-header">
    <h4 class="modal-title"
      >{{ track().name }}
      @if (track().version) {
        - V{{ track().version }}
      }
    </h4>
    <div class="ms-auto d-flex align-items-center gap-2">
      <button type="button" class="btn btn-tertiary btn-sm" (click)="toggleFullscreen()">
        {{
          isFullscreen()
            ? ('MAP.EXIT_FULLSCREEN' | translate)
            : ('MAP.ENTER_FULLSCREEN' | translate)
        }}
      </button>
    </div>
    <button
      type="button"
      class="btn btn-circle btn-ghost element-cancel"
      aria-label="Close modal"
      (click)="closeModal()"
    ></button>
  </div>

  <div class="map-modal__body modal-body">
    @if (routeWaypoints(); as waypoints) {
      <app-brouter-map
        class="map-modal__map h-100 w-100 d-block"
        [waypoints]="waypoints"
        [readonly]="true"
        (editRequested)="openEditTool(waypoints)"
      />
    } @else {
      <div class="d-flex justify-content-center align-items-center brouter-empty-state-container">
        <si-empty-state
          empty-content
          icon="element-location"
          heading="No Route Data Available"
          description="This track was not imported from BRouter or the route data is missing."
        />
      </div>
    }
  </div>
</ng-template>
